import React from 'react';
import css from './HunterServiceStatus.module.scss';
import { HunterServiceStatusType } from '../../../API/Enums';
import classNames from 'classnames';
import { useLocalization } from '../../../context/Localization/localization';
import { IconTypes } from '../../Icon/GenericIcon/GenericIcon.types';
import { GMSizedIcon } from '../../Icon';

interface IHunterServiceStatusProps {
    label: string;
    status: HunterServiceStatusType;
}

export const HunterServiceStatus = React.memo((props: IHunterServiceStatusProps) => {
    const Localization = useLocalization();
    let icon: IconTypes;
    let className: string = '';
    let ariaLabel: string | undefined;

    switch (props.status) {
        case HunterServiceStatusType.NoData:
            icon = 'Warn';
            className = css.nodata;
            break;
        /*
         * right now marginal and recommended do the same thing
         * this code was added in case a specific status for margnial is needed
         */
        case HunterServiceStatusType.Recommended:
            icon = 'Fail';
            ariaLabel = Localization.FailedInspectionIcon;
            className = css.recommended;
            break;
        case HunterServiceStatusType.Marginal:
            icon = 'Fail';
            ariaLabel = Localization.FailedInspectionIcon;
            className = css.recommended;
            break;
        case HunterServiceStatusType.OK:
            icon = 'Success';
            ariaLabel = Localization.PassedInspectionIcon;
            className = css.ok;
            break;
    }

    return (
        <div className={classNames(css.hunterServiceStatus, className)}>
            <div className={css.icon}>
                <GMSizedIcon
                    iconType={icon}
                    iconSize={'custom'}
                    ariaLabel={ariaLabel}
                />
            </div>
            <div className={css.labelContainer}>
                <h4 className={css.label}>{props.label}</h4>
            </div>
        </div>
    );
});
